export default "__VITE_ASSET__C421uWYn__"